import { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import AboutUs from './AboutUs'
import ContentSettings from './ContentSettings'
import Dashboard from './Dashboard'
import Notifications from './Notifications'
import TransactionHistory from './TransactionHistory'
import Realtime from './Realtime'
import Password from './Password'
import Support from './Support'
import ChatRules from './ChatRules'
import { UserServices, AuthServices } from 'services'
import { useRouter } from 'next/router'
import Cookies from 'js-cookie'
import { RegisterOverlay, UpgradeModal, MinutePackagesModal, BankStatementModal, PremiumWelcomeModal, MediaFullscreen, FreeMinutesModal, ConfirmEmailModal, SignOutModal, SuspendModal, AccountSuspendedModal, QuickSettingsModal, Referral, TierModal, RegisterGetMinutes, PaymentAttemts, Histories, NoticeModal, WeekendBonus, VerifyAgeModal, CuroModal, PaymentBlockModal, PersonalUpdateModal, DailyCheckin, IdentifyVerificationModal, QuestBonus, Ranking, NewVersionModal, AgeVerificationBlock, ForgotPassword } from 'components/common/index'
import {
  setRegisterModal, setUpgradeModal, setNewEvent, cancelFriendRequest, receiveFriendRequest, acceptFriendRequest, setUserStatus,
} from 'actions'
import { 
  ECHO_CALL_REQUEST, ECHO_NEW_MESSAGE, ECHO_CALL_DECLINED, ECHO_CALL_ACCEPTED, ECHO_CALL_CANDIDATE, ECHO_CALL_ANSWERED,
  ECHO_CALL_ENDED, ECHO_CALL_REQUESTED, ECHO_MESSAGE_READ_EVENT, ECHO_CALL_START, ECHO_CALL_POSITION,
  ECHO_NEW_NOTICE,
  ECHO_FRIEND_CHANGE,
  ECHO_BAN,
  ECHO_CALL_UPDATED,
} from 'constants/realtimeEvent'
import { logout, setUser } from 'actions/connection'
import i18n from 'config/i18n'
import dynamic from 'next/dynamic'
import { FriendServices, HistoryServices, MessageServices, RealtimeServices, StoryService } from 'services/index'
import { setActiveConversation, setMainContent } from 'actions'
import MessageNotificaton from './MessageNotification'
import { deleteChannel, setUnreadMessage, setWebsocketConnected } from 'actions/echo'
import { addCacheImages, removeCacheImage, setActiveSidebar, setCacheImages, setNoticeModal, setShowNewVersionModal, setSignOutModal, setStories, setStoriesModal, setVerifyAgeModal, setWeeklyBonusModal, setYotiVerifyModal } from 'actions/mainContent'
import moment from 'moment'
import { SignOut } from 'assets/icons/components'
import {
  SignOutAction, Text
} from './style'
import { addConversation, addMessage, setConversations } from 'actions/chat'
import { addRecentUser, setIsFullScreen, setRecentUsers } from 'actions/videoCall'
import { useTranslation } from 'react-i18next'
import { setFriendRequests, setFriends } from 'actions/relationship'
import config from 'config'
import { isNewerVersion } from 'ultils'
import { usesManualDocumentVerification } from 'ultils/documentVerificationRoute'
import ModelAgreement from './ModelAgreement/ModelAgreement'
import axios from 'axios'
import Subscription from './Subscription/index'
// import FingerprintJS from '@fingerprintjs/fingerprintjs'

// const fpPromise = FingerprintJS.load()

const VideoCall = dynamic(() => import('./VideoCall'))

// Code-split: these are off the initial /live path (conditional modals or
// non-default content panels). Import the CONCRETE file path, never the barrel,
// so webpack actually splits them. ssr:false — /live is auth-gated + noindex.
const WithdrawModal = dynamic(() => import('components/common/WithdrawModal'), { ssr: false })
const YotiVerifyModal = dynamic(() => import('components/common/YotiVerifyModal'), { ssr: false })
const BoostModal = dynamic(() => import('components/common/BoostModal'), { ssr: false })
// StoriesModal & MediaFullscreen have no folder index.js — use the nested path.
const StoriesModal = dynamic(() => import('components/common/StoriesModal/StoriesModal'), { ssr: false })
// GiftFirework is always mounted but statically pulls the fireworks-js vendor lib;
// deferring it keeps that lib out of the initial chunk.
const GiftFirework = dynamic(() => import('components/common/GiftFirework'), { ssr: false })
// Content panels — rendered one-at-a-time via contentKey; default is 'dashboard'.
const Chat = dynamic(() => import('./Chat'), { ssr: false })
const Monetization = dynamic(() => import('./Monetization'), { ssr: false })
const Story = dynamic(() => import('./Story'), { ssr: false })
const PersonalInformation = dynamic(() => import('./PersonalInformation'), { ssr: false })

const MainContent = (props) => {
  const { 
    contentKey, documentTitle, isShowRegisterModal, dispatch, isShowUpgradeModal, user, echoServer,
    isShowMinutePackagesModal, activeConversation, storiesModal,
    fullscreenMediaSrc, isShowSignOutModal, isShowSuspendModal,
    isShowQuickSettingsModal, isShowReferralModal, isShowTierModal,
    isShowWithdrawModal, cacheImages, isShowRegisterGetMinutesModal,
    listConversations, isShowPaymentAttemptsModal, isSearching,
    isShowNoticeModal, newEvent, isShowVerifyAgeModal, isShowWeeklyBonusModal,
    blockPaymentLink, isWebsocketConnected, isShowIdentifyVerificationModal,
    isShowQuestBonusModal, isShowRankingsModal, isShowNewVersionModal, ageVerificationBlockLink,
    isShowYotiVerifyModal
  } = props
  const { t } = useTranslation('live', { i18n })
  const router = useRouter()
  const audioRingtone = useRef(null)

  const [purchasedPackage, setPurchasedPackage] = useState(null)
  const [isLoadingCacheImage, setIsLoadingCacheImage] = useState(false)
  const [isLoadingGetConversation, setIsLoadingGetConversation] = useState(false)
  const [isShowPaymentModal, setIsShowPaymentModal] = useState(false)
  const [isShowDailyCheckin, setIsShowDailyCheckin] = useState(false)
  const [countTime, setCountTime] = useState(0)
  const [userChannel, setUserChannel] = useState(null)
  const [version, setVersion] = useState(config.APP_VERSION)
  const forgotPassordRef = useRef()

  useEffect(() => {
    if (documentTitle.inCommingCall) {
      document.title = documentTitle.inCommingCall
    } else {
      document.title = `${documentTitle.newMessages + documentTitle.newRequests > 0 ? `(${documentTitle.newMessages + documentTitle.newRequests})` : ''} ${documentTitle.default}`
    }
  }, [documentTitle])

  useEffect(() => {
    if (!activeConversation && contentKey === 'chat') {
      dispatch(setMainContent('dashboard'))
    }
  }, [activeConversation])

  useEffect(() => {
    let queries = new URLSearchParams(location.search)
    if (queries.get('chat')) {
      getConversation(queries.get('chat'))
    }

    if (queries.get('model')) {
      getConversationByModelUid(queries.get('model'))
    }

    audioRingtone.current = new Audio('/sound/message.mp3')

    let interval = setInterval(() => {
      setCountTime(prev => prev + 1)
    }, 1000)

    return () => clearInterval(interval)
    
  }, [])

  useEffect(() => {
    if (newEvent?.event === ECHO_NEW_MESSAGE) {
      handleNewMessage(newEvent.message)
    }
  }, [newEvent])

  useEffect(() => {
    // Remember the channel we actually joined so the cleanup below can leave
    // exactly that one. Recomputing the name from `user` at cleanup time is not
    // safe: logout nulls `user` while leaving `echoServer` in place.
    let joinedChannel = null

    if (echoServer && isWebsocketConnected && user?.uid) {
      joinedChannel = `user.${user.uid}`
      const channel = echoServer.private(joinedChannel)
        .listen('Message\\CreatedEvent', (args) => {
          if (document.hidden && args?.message?.type !== 'Gift') {
            user?.notices?.sound !== false && audioRingtone.current.play().catch(() => {})
          }
          dispatch(setNewEvent({ event: ECHO_NEW_MESSAGE, message: args.message }))
          dispatch(addMessage({ message: args.message }))
        })
        .listen('Friend\\CancelledEvent', (args) => {
          dispatch(cancelFriendRequest(args.relationship))
          dispatch(setNewEvent({ event: ECHO_FRIEND_CHANGE, relationship: args.relationship }))
        })
        .listen('Friend\\RequestedEvent', (args) => {
          dispatch(receiveFriendRequest(args.relationship, args.conversationToken, null))
          dispatch(setNewEvent({ event: ECHO_FRIEND_CHANGE, relationship: args.relationship }))
        })
        .listen('Friend\\AcceptedEvent', (args) => {
          dispatch(acceptFriendRequest(args.relationship))
          dispatch(setNewEvent({ event: ECHO_FRIEND_CHANGE, relationship: args.relationship }))
        })
        .listen('Call\\StartEvent', (args) => {
          dispatch(setNewEvent({ event: ECHO_CALL_START, ...args }))
        })
        .listen('Call\\PositionEvent', (args) => {
          dispatch(setNewEvent({ event: ECHO_CALL_POSITION, position: args.position }))
        })
        .listen('Call\\RequestEvent', (args) => {
          dispatch(setNewEvent({ event: ECHO_CALL_REQUEST, caller: args.caller, callId: args.callId, iceServers: args.iceServers, isDirect: args.isDirect, isLivekit: args.isLivekit }))
        })
        .listen('Call\\RequestedEvent', (args) => {
          dispatch(setNewEvent({ event: ECHO_CALL_REQUESTED, callId: args.callId, isLivekit: args.isLivekit }))
        })
        .listen('Call\\DeclinedEvent', () => {
          dispatch(setNewEvent({ event: ECHO_CALL_DECLINED }))
        })
        .listen('Call\\AcceptedEvent', () => {
          dispatch(setNewEvent({ event: ECHO_CALL_ACCEPTED }))
        })
        .listen('Call\\CandidateEvent', (args) => {
          dispatch(setNewEvent({ event: ECHO_CALL_CANDIDATE, candidate: args.candidate }))
        })
        .listen('Call\\Updated', (args) => {
          dispatch(setNewEvent({ event: ECHO_CALL_UPDATED, ...args }))
        })
        .listen('Call\\AnsweredEvent', (args) => {
          dispatch(setNewEvent({ ...args, event: ECHO_CALL_ANSWERED }))
        })
        .listen('Message\\ReadEvent', (args) => {
          dispatch(setNewEvent({ ...args, event: ECHO_MESSAGE_READ_EVENT }))
        })
        .listen('Payment\\PurchasedEvent', (args) => {
          getCurrentUser()
          setIsShowPaymentModal(true)
          setPurchasedPackage(args.package)
          Cookies.get('gclid') && window.gtag && gtag('event', 'conversion', {
            send_to: 'AW-17596970317/Nz_lCODq4socEM3q8cZB',
            transaction_id: args?.package?.id,
          })
        })
        .listen('Payment\\Failed', () => {
          setIsShowPaymentModal(true)
          setPurchasedPackage(null)
        })
        .listen('Call\\EndedEvent', (args) => {
          dispatch(setNewEvent({ ...args, event: ECHO_CALL_ENDED }))

          if (args.callRecent) {
            dispatch(addRecentUser(args.callRecent))
          }
        })
        .listen('User\\LoggedEvent', (args) => {
          router.push('/')
        })
        .listen('Message\\UnreadEvent', (args) => {
          dispatch(setUnreadMessage(args.total))
        })
        .listen('Message\\DeletedChannelEvent', (args) => {
          dispatch(deleteChannel(args.token))
        })
        .listen('User\\OnlineStatusEvent', (args) => {
          dispatch(setUserStatus({ ...args.user, online: args.online }))
        })
        .listen('User\\BanEvent', () => {
          dispatch(setNoticeModal(true))
          dispatch(setNewEvent({ event: ECHO_BAN }))
        })
        .listen('User\\UpdatedEvent', (args) => {
          if (args?.user?.is_verify_identity) {
            // The server already withholds this from models who cannot use
            // Yoti; guarded here too so an older payload cannot open a sheet
            // that dead-ends for them.
            if (!usesManualDocumentVerification(user)) {
              dispatch(setYotiVerifyModal(true))
            }
            return;
          }

          if (args?.user?.session_id && user.session_id && args?.user?.session_id !== user.session_id) {
            echoServer.disconnect()
          } else {
            dispatch(setUser({
              ...args.user,
              enable_christmas_bonus: false
          }))
          }
        })
        .listen('Notice\\Created', (args) => {
          dispatch(setNewEvent({ event: ECHO_NEW_NOTICE }))
        })
        .listen('System\\NewVersionEvent', (args) => {
          if (args?.version) {
            setVersion(args.version)
          }

          if (isNewerVersion(args?.version, config.APP_VERSION)) {
            dispatch(setShowNewVersionModal(true))
          }
        })
        .on('subscription_error', () => {
          dispatch(setWebsocketConnected(false))
          // location.reload()
        })
        .error((err) => {
          dispatch(setWebsocketConnected(false))
        })

      setTimeout(() => {
        channel && channel.whisper('Action', { action: 'Visited'})
      }, 5000)
      

      setUserChannel(channel)

      if (user?.monetization_status === 3 && user?.model_agreement) {
        dispatch(setWeeklyBonusModal(true))
      }
    }

    return () => {
      // This cleanup runs on every dep change, including the ones where the
      // effect body was skipped. `echoServer` is not a dependency and `user` is
      // nulled by logout, so both can be gone by now — guard on the channel we
      // recorded above rather than dereferencing either one blindly.
      if (echoServer && joinedChannel) {
        echoServer.leave(joinedChannel)
      }
    }
  }, [isWebsocketConnected, user?.uid])

  useEffect(() => {
    if (!isSearching && user?.gender === 1) {
      UserServices.endSearching()
    }
  }, [isSearching])

  useEffect(() => {
    if (user?.uid) {
      setIsShowDailyCheckin(user?.is_allow_checkin )
      initPrecacheResources()
    }
  }, [user?.uid])

  useEffect(() => {
    if (user?.role === 'guest') {
      dispatch(setUnreadMessage(1))
    }

    if (activeConversation?.type === 'REGISTER') {
      dispatch(setMainContent('dashboard'))
      dispatch(setActiveConversation(null))
    }

    if (user?.gender === 1 && user?.monetization_status === 3 && !user?.model_agreement) {
      dispatch(setMainContent('monetization'))
      dispatch(setIsFullScreen(false))
    }
  }, [user])

  useEffect(() => {
    if (!isLoadingCacheImage && cacheImages.length) {
      setIsLoadingCacheImage(true)
      let cacheImage = cacheImages.shift()

      let img = document.createElement("img");
      img.src = cacheImage

      img.addEventListener('load', () => {
        setIsLoadingCacheImage(false)
        dispatch(removeCacheImage(cacheImage))
      })

      img.addEventListener('error', () => {
        setIsLoadingCacheImage(false)
        dispatch(removeCacheImage(cacheImage))
      })
    }
  }, [cacheImages])

  useEffect(() => {
    if (['ru', 'es', 'en', 'fr', 'ko', 'da', 'de', 'ja', 'sv', 'no', 'it', 'tr', 'pt', 'nl', 'fi', 'zh', 'cs', 'ro', 'pl'].includes(user?.language)) {
      moment.locale(user?.language)
      i18n.changeLanguage(user.language)
      axios.defaults.headers.common['Locale'] = user?.language
    }
  }, [user?.language])

  const getConversation = async (token) => {
    const { conversation } = await HistoryServices.getConversation(token)

    if (conversation) {
      dispatch(setActiveConversation(conversation))
      dispatch(setMainContent('chat'))
    }
  }

  const getConversationByModelUid = async (uid) => {
    const { conversation } = await HistoryServices.getConversationByModelUid(uid)

    if (conversation) {
      dispatch(setActiveSidebar('messages'))
      dispatch(setActiveConversation(conversation))
      dispatch(setMainContent('chat'))
    }
  }

  const getCurrentUser = async () => {
    const { user: authUser, error } = await UserServices.getProfile()

    if (authUser) {
      dispatch(setUser({
        ...authUser,
        enable_christmas_bonus: false
      }))

      if (authUser?.is_show_verify_age && authUser?.require_age_verification) {
        dispatch(setVerifyAgeModal(true))
      }

      if (authUser?.enable_christmas_bonus) {
        setTimeout(() => {
          dispatch(setUser({
            ...authUser,
            enable_christmas_bonus: true
          }))
        }, 10000)
      }
    }
  }
  
  const handleCloseRegisterModal = () => {
    dispatch(setRegisterModal(false))
    dispatch(setUpgradeModal(false))
  }

  const handleCloseUpgradeModal = () => {
    dispatch(setUpgradeModal(false))
    dispatch(setRegisterModal(false))
  }

  const handleNewMessage = async (message) => {
    if (!message) return;

    let index = listConversations.findIndex(c => message?.conversation?.token === c?.token)

    if (index !== -1) {
      listConversations[index].lastMessage = {
        content: message.content,
        created_at: message.created_at,
        type: message.type,
      }

      if (!message?.read && !message?.system && activeConversation?.token !== listConversations[index].token) {
        listConversations[index].unread++
      }

      dispatch(setConversations([listConversations[index], ...listConversations.filter(c => c.token !== listConversations[index].token)]))
    } else {
      getConversationByToken(message?.conversation?.token)
    }
  }

  const getConversationByToken = async (token) => {
    if (isLoadingGetConversation) return

    let existsConversation = listConversations.find(item => item?.token === token)

    if (!existsConversation) {
      setIsLoadingGetConversation(true)
      let { conversation } = await HistoryServices.getConversation(token)
      setIsLoadingGetConversation(false)
      existsConversation = conversation
    }

    if (existsConversation) {
      dispatch(addConversation(existsConversation))
    }
  }

  const content = [
    {
      key: 'dashboard',
      component: <Dashboard countTime={countTime} />
    },
    {
      key: 'personal-information',
      component: <PersonalInformation />
    },
    {
      key: 'notifications',
      component: <Notifications />
    },
    {
      key: 'content-settings',
      component: <ContentSettings />
    },
    {
      key: 'payment-history',
      component: <TransactionHistory />
    },
    {
      key: 'subscription',
      component: <Subscription />
    },
    {
      key: 'about-us',
      component: <AboutUs version={version}/>
    },
    {
      key: 'chat',
      component: <Chat />
    },
    {
      key: 'monetization',
      component: <Monetization />
    },
    {
      key: 'password',
      component: <Password />
    },
    {
      key: 'support',
      component: <Support />
    },
    {
      key: 'chat-rules',
      component: <ChatRules />
    },
    {
      key: 'story',
      component: <Story />
    },
    {
      key: 'model-agreement',
      component: <ModelAgreement />
    }
  ]

  const handleLogout = () => {
    dispatch(setSignOutModal(true))
  }

  const initPrecacheResources = async () => {
    if (user?.is_banned) return;

    // Stories
    if (user?.role !== 'guest' && user?.gender === 0) {
      const { stories } = (await StoryService.public({ limit: 5, page: 1 })) || {}
      if (stories) {
        dispatch(setStories({
          queries: { limit: 5, page: 1 },
          items: stories
        }))
        let images = stories.map(s => s.thumbnail)
        dispatch(addCacheImages(images))
      }
    }

    if (user?.role !== 'guest') {
      getFriends()
      getFriendRequests()
    } else {
      dispatch(setFriends([]))
      dispatch(setFriendRequests([]))
    }

    // Specific story
    let queries = new URLSearchParams(location.search)

    if (queries.get('s')) {
      dispatch(setStoriesModal({
        isShow: true,
        uid: queries.get('s')
      }))
    }

    // Conversations
    const { conversations } = (await HistoryServices.getConversations({ page: 1, per_page: 20 })) || {}
    if (conversations) {
      dispatch(setConversations(conversations))
      dispatch(addCacheImages(conversations.map(c => c?.participant?.avatar)))
      
      // if (user?.role === 'user') {
      //   getSupportConversation()
      // }
    }
  }

  const getSupportConversation = async () => {
    if (user?.role !== 'user') return;

    let { conversation } = await HistoryServices.getSupportConversation()

    if (conversation) {
      dispatch(addConversation(conversation))
    }
  }

  const getFriends = async () => {
    try {
      let { friends } = await FriendServices.getFriends({ page: 1, per_page: 15})
      if (friends) {
        friends = friends.sort(item => item?.sender?.online ? -1 : 1)
        dispatch(setFriends(friends))
      }
    } catch (e) {
      console.log(e)
    }
  }

  const getFriendRequests = async () => {
    try {
      let { friends } = await FriendServices.getRequestFriends()
      dispatch(setFriendRequests(friends))
    } catch (e) {
      console.log(e)
    }
  }
  
  return (
    <>
      { isShowNewVersionModal ? <NewVersionModal /> : <></> }
      <div className='live-container__main-content'>
        { contentKey && content.find(k => k.key === contentKey)?.component }
        {
          contentKey === 'personal-information' && !storiesModal?.isShow
          ?
            <SignOutAction
              onClick={() => handleLogout()}
            >
              <Text>{t('Sign out')}</Text> <SignOut />
            </SignOutAction>
          :<></>
        }
      </div>
      {/* Realtime renders only overlays (DisconnectOverlay / DuplicateLoginModal).
          It must sit OUTSIDE .live-container__main-content: on mobile that div is
          `position:absolute; z-index:2`, whose stacking context traps DisconnectOverlay's
          z-index and lets Histories (also z-index:2, later in DOM) paint over it. Keeping it
          a top-level sibling — like every other overlay modal below — fixes that. */}
      <Realtime />
      <VideoCall userChannel={userChannel} />
      <MessageNotificaton />
      <RegisterOverlay
        handleCloseRegisterModal={handleCloseRegisterModal}
        isShowRegisterModal={isShowRegisterModal}
        forgotPassordRef={forgotPassordRef}
      />

      <ForgotPassword t={t} ref={forgotPassordRef} isHideLabel={true}/>

      <UpgradeModal
        handleCloseUpgradeModal={handleCloseUpgradeModal}
        isShowUpgradeModal={isShowUpgradeModal}/>
      <ConfirmEmailModal></ConfirmEmailModal>
      { storiesModal?.isShow ? <StoriesModal></StoriesModal> : <></> }
      { fullscreenMediaSrc ? <MediaFullscreen></MediaFullscreen> : <></> }
      <MinutePackagesModal />
      { user?.offer_5_minutes ? <FreeMinutesModal /> : <></> }
      { isShowSignOutModal ? <SignOutModal></SignOutModal> : <></>}
      { isShowSuspendModal ? <SuspendModal></SuspendModal> : <></>}
      <AccountSuspendedModal />
      { isShowQuickSettingsModal ? <QuickSettingsModal></QuickSettingsModal> : <></> }
      { isShowReferralModal ? <Referral></Referral> : <></> }
      { isShowTierModal ? <TierModal /> : <></> }
      { isShowWithdrawModal ? <WithdrawModal></WithdrawModal> : <></> }
      { isShowRegisterGetMinutesModal ? <RegisterGetMinutes></RegisterGetMinutes> : <></> }
      { isShowPaymentAttemptsModal ? <PaymentAttemts></PaymentAttemts> : <></> }
      { isShowNoticeModal ? <NoticeModal></NoticeModal> : <></> }
      <BankStatementModal />
      { isShowDailyCheckin ? <DailyCheckin onClose={() => setIsShowDailyCheckin(false)}/> : <></> }
      { isShowRankingsModal ? <Ranking /> : <></> }
      { isShowIdentifyVerificationModal ? <IdentifyVerificationModal /> : <></> }
      { isShowYotiVerifyModal ? <YotiVerifyModal /> : <></> }
      {/* Daily check-in gets the screen first. Closing it flips is_allow_checkin
          off (DailyCheckin dispatches the partial setUser), which is what lets the
          boost modal through — keyed off the user flag rather than isShowDailyCheckin
          alone so it can't flash up in the render before that state is set. */}
      { user?.is_show_boost && !user?.is_allow_checkin && !isShowDailyCheckin ? <BoostModal /> : <></> }
      { blockPaymentLink ? <PaymentBlockModal /> : <></> }
      { isShowVerifyAgeModal ? <VerifyAgeModal /> : <></> }
      { isShowWeeklyBonusModal ? <WeekendBonus /> : <></> }
      { ageVerificationBlockLink ? <AgeVerificationBlock /> : <></> }
      { isShowPaymentModal
        ? 
        <PremiumWelcomeModal
          close={() => setIsShowPaymentModal(false)}
          selectedPackage={purchasedPackage}
        ></PremiumWelcomeModal> 
        : <></>
      }
      {
        user?.role === 'user' && user?.gender === 0 && user?.ages === null
        ?
          <PersonalUpdateModal />
        : <></>
      }
      {
        !(user?.role === 'guest' && user?.gender === 1) && (
          <Histories></Histories>
        )
      }
      {
        isShowQuestBonusModal ? <QuestBonus></QuestBonus> : <></>
      }
      <GiftFirework></GiftFirework>
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
  isShowRegisterModal: state.mainContentReducer.isShowRegisterModal,
  contentKey: state.mainContentReducer.contentKey,
  documentTitle: state.mainContentReducer.documentTitle,
  isShowUpgradeModal: state.mainContentReducer.isShowUpgradeModal,
  echoServer: state.connectionReducer.echoServer,
  accessToken: state.connectionReducer.accessToken,
  isShowMinutePackagesModal: state.mainContentReducer.isShowMinutePackagesModal,
  activeConversation: state.chatReducer.activeConversation,
  fullscreenMediaSrc: state.mainContentReducer.fullscreenMediaSrc,
  storiesModal: state.mainContentReducer.storiesModal,
  isShowSignOutModal: state.mainContentReducer.isShowSignOutModal,
  isShowSuspendModal: state.mainContentReducer.isShowSuspendModal,
  isShowQuickSettingsModal: state.mainContentReducer.isShowQuickSettingsModal,
  isShowReferralModal: state.mainContentReducer.isShowReferralModal,
  isShowTierModal: state.mainContentReducer.isShowTierModal,
  isShowWithdrawModal: state.mainContentReducer.isShowWithdrawModal,
  listConversations: state.chatReducer.conversations,
  activeConversation: state.chatReducer.activeConversation,
  cacheImages: state.mainContentReducer.cacheImages,
  isShowRegisterGetMinutesModal: state.mainContentReducer.isShowRegisterGetMinutesModal,
  isShowPaymentAttemptsModal: state.mainContentReducer.isShowPaymentAttemptsModal,
  isSearching: state.videoCallReducer.isSearching,
  isShowNoticeModal: state.mainContentReducer.isShowNoticeModal,
  newEvent: state.echoReducer.newEvent,
  isShowVerifyAgeModal: state.mainContentReducer.isShowVerifyAgeModal,
  isShowWeeklyBonusModal: state.mainContentReducer.isShowWeeklyBonusModal,
  blockPaymentLink: state.mainContentReducer.blockPaymentLink,
  isWebsocketConnected: state.echoReducer.isWebsocketConnected,
  isShowIdentifyVerificationModal: state.mainContentReducer.isShowIdentifyVerificationModal,
  isShowYotiVerifyModal: state.mainContentReducer.isShowYotiVerifyModal,
  isShowQuestBonusModal: state.mainContentReducer.isShowQuestBonusModal,
  isShowRankingsModal: state.mainContentReducer.isShowRankingsModal,
  isShowNewVersionModal: state.mainContentReducer.isShowNewVersionModal,
  ageVerificationBlockLink: state.mainContentReducer.ageVerificationBlockLink
})

export default connect(mapStateToProps)(MainContent)
